import React from "react"
import PropTypes from "prop-types"
import Radium from "higher-order-components/configured-radium/"
import { CheckBox } from "components"

function ServiceListSelect({
  services = [],
  selectedServices = {},
  compact = true,
  onServiceClick = () => {}
}) {
  return (
    <ul style={styles.list}>
      {services.map(service => {
        const isSelected = !!selectedServices[service.code]

        return (
          <li
            key={service.code}
            onClick={() => onServiceClick(service.code)}
            style={{
              ...styles.service(compact),
              ...(isSelected ? styles.selected : {})
            }}>
            <div style={styles.checkboxContainer(compact)}>
              <CheckBox
                checked={isSelected}
                onClick={e => {
                  e && e.stopPropagation()
                  onServiceClick(service.code)
                }} />
            </div>

            <div style={styles.details(compact)}>
              <div style={styles.content}>
                {service.name && <div style={styles.name}>{service.name}</div>}
                {!compact &&
                  service.description && (
                    <div style={styles.description}>{service.description}</div>
                  )}
              </div>
              {service.price && <div style={styles.price}>{service.price}</div>}
            </div>
          </li>
        )
      })}
    </ul>
  )
}

ServiceListSelect.propTypes = {
  services: PropTypes.array,
  selectedServices: PropTypes.object,
  compact: PropTypes.bool,
  onServiceClick: PropTypes.func
}

const styles = {
  list: {
    margin: 0,
    padding: 0,
    listStyleType: "none",
    display: "block",
    width: "100%"
  },
  service: compact => ({
    boxSizing: "border-box",
    padding: compact ? "2em 0 1.8em" : "2em 1em 1.8em 0",
    display: "flex",
    borderTop: "1px solid rgb(203, 203, 203)",
    margin: 0,
    width: "100%",
    listStyleType: "none",
    cursor: "pointer",
    ...(compact ? { alignItems: "center" } : {}),
    ":hover": {
      backgroundColor: "#f5f5f5"
    }
  }),
  selected: {
    backgroundColor: "#f5f5f5"
  },
  checkboxContainer: compact => ({
    flexGrow: 0,
    flexShrink: 0,
    margin: compact ? "0" : "0 1em 0 0",
    transform: "scale(0.9)"
  }),
  details: compact => ({
    textAlign: "left",
    flexGrow: 1,
    display: "flex",
    ...(compact ? { alignItems: "center" } : {})
  }),
  content: {
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    flexBasis: "100%" // This is added for IE 11 only.
  },
  name: {
    fontWeight: 400,
    lineHeight: 1.2
  },
  description: {
    fontWeight: 200,
    lineHeight: 1.5,
    margin: "1em 0 0"
  },
  price: {
    fontWeight: 600,
    flexGrow: 0,
    flexShrink: 0,
    marginLeft: "2em"
  }
}

export default Radium(ServiceListSelect)



// WEBPACK FOOTER //
// ./src/containers/service-list-select/index.jsx